<template>
  <div class="block mt-xs-107">
    <!-- interval=10000ms 9s镜头动画 + 1s停留 -->
    <el-carousel class="self-carousel" :interval="8000" @change="switchBanner" arrow="hover">

      <!-- 第四张轮播 -->
      <el-carousel-item>
        <div class="img-wrap" :class="{ playAnim: activeIndex === 0 }">
          <img 
            :src="wWidth < 768 ? img_list[5] : img_list[2]" 
            alt="CT/MRI桌面孪生教学机 医学影像实训设备"
            loading="lazy"
            decoding="async"
          >
          <div class="mask-layer"></div>
          <div class="hero-content">
            <div class="hero-text">
              <span class="hero-badge">
                <i class="fa fa-microscope"></i> 医学影像智慧教育
              </span>
              <h2 class="hero-title">
                桌面式教学机
                <span class="hero-subtitle">CT、MRI教学机（桌面孪生版）</span>
              </h2>
              <p class="hero-desc">
                医影智能CT/MRI孪生版桌面教学机严格按照临床真机1:2.5微缩复刻，完整保留真机全部核心功能。
              </p>
              <router-link to="/desktop" aria-label="前往桌面孪生教学机详情页面">
                <button class="but">查看详情</button>
              </router-link>
            </div>
            <div class="hero-image hero-image-desktop" data-aos="fade-left">
              <img 
                src="@/assets/image/d3.jpg" 
                alt="CT MRI桌面孪生教学机"
                loading="lazy"
                decoding="async"
              >
            </div>
          </div>
        </div>
      </el-carousel-item>

      <!-- 第三张轮播 -->
      <el-carousel-item>
        <div class="img-wrap" :class="{ playAnim: activeIndex === 1 }">
          <img 
            :src="wWidth < 768 ? img_list[5] : img_list[2]" 
            alt="DR数字化X线摄影影像实训中心"
            loading="lazy"
            decoding="async"
          >
          <div class="mask-layer"></div>
          <div class="hero-content">
            <div class="hero-text">
              <span class="hero-badge">
                <i class="fa fa-microscope"></i> 医学影像智慧教育
              </span>
              <h2 class="hero-title">
                数字化 X 线摄影
                <span class="hero-subtitle">DR 影像实训中心</span>
              </h2>
              <p class="hero-desc">
                标准化拍片流程 + 影像阅片训练，掌握骨骼、胸部基础影像，夯实临床技能。
              </p>
              <router-link to="/DR" aria-label="前往DR数字化X线摄影详情页面">
                <button class="but">查看详情</button>
              </router-link>
            </div>
            <div class="hero-image hero-image-dr" data-aos="fade-left">
              <img 
                src="@/assets/image/6.png" 
                alt="DR数字化X线摄影设备"
                loading="lazy"
                decoding="async"
              >
            </div>
          </div>
        </div>
      </el-carousel-item>

      <!-- 第二张轮播 -->
      <el-carousel-item>
        <div class="img-wrap" :class="{ playAnim: activeIndex === 2 }">
          <img 
            :src="wWidth < 768 ? img_list[4] : img_list[1]" 
            alt="CT计算机断层扫描高清成像系统-人体模体实训"
            loading="lazy"
            decoding="async"
          >
          <div class="mask-layer"></div>
          <div class="hero-content">
            <div class="hero-text hero-text-ct">
              <span class="hero-badge">
                <i class="fa fa-microscope"></i> 医学影像智慧教育
              </span>
              <h2 class="hero-title">
                计算机断层扫描
                <span class="hero-subtitle">CT 高清成像系统</span>
              </h2>
              <p class="hero-desc">
                多排螺旋 CT 仿真操作，断层解剖学习，快速掌握胸部、腹部、颅脑影像诊断。
              </p>
              <router-link to="/CT" aria-label="前往CT成像系统详情页面">
                <button class="but">查看详情</button>
              </router-link>
            </div>
            <div class="hero-image hero-image-ct" data-aos="fade-left">
              <img 
                src="@/assets/image/4.png" 
                alt="CT设备与躯干人体模体"
                loading="lazy"
                decoding="async"
              >
            </div>
          </div>
        </div>
      </el-carousel-item>

      <!-- 第一张轮播 -->
      <el-carousel-item>
        <div class="img-wrap" :class="{ playAnim: activeIndex === 3 }">
          <img 
            :src="wWidth < 768 ? img_list[3] : img_list[0]" 
            alt="MRI磁共振成像智能诊断平台-医学影像智慧教育"
            loading="lazy"
            decoding="async"
          >
          <!-- 提亮渐变遮罩层 -->
          <div class="mask-layer"></div>
          <!-- 文字内容层 -->
          <div class="hero-content">
            <div class="hero-text">
              <span class="hero-badge">
                <i class="fa fa-microscope"></i> 医学影像智慧教育
              </span>
              <h2 class="hero-title">
                磁共振成像
                <span class="hero-subtitle">MRI 智能诊断平台</span>
              </h2>
              <p class="hero-desc">
                高精度软组织成像 + AI 辅助分析，从解剖结构到病变识别，全方位提升诊断能力。
              </p>
              <router-link to="/MRI" aria-label="前往MRI磁共振成像详情页面">
                <button class="but">查看详情</button>
              </router-link>
            </div>
            <div class="hero-image hero-image-mri" data-aos="fade-left">
              <img 
                src="@/assets/image/5.png" 
                alt="MRI磁共振医疗设备"
                loading="lazy"
                decoding="async"
              >
            </div>
          </div>
        </div>
      </el-carousel-item>
      
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img_list: [
        require('@/assets/image/bgblue.png'),
        require('@/assets/image/bgblue.png'),
        require('@/assets/image/bgblue.png'),
        require('@/assets/phone/bgRoll.png'),
        require('@/assets/phone/bgRoll2.png'),
        require('@/assets/phone/bgRoll3.png')
      ],
      wWidth: document.documentElement.clientWidth,
      activeIndex: null
    }
  },
  mounted() {
    // 窗口宽度监听更新
    this.resizeHandler = () => {
      this.wWidth = document.documentElement.clientWidth
    }
    window.addEventListener('resize', this.resizeHandler)
    // 初始化执行第一张镜头动画
    setTimeout(() => {
      this.activeIndex = 0
    }, 10)
  },
  beforeDestroy() {
    // 修复：移除同一个函数实例，彻底清除监听
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    // 切换轮播重置镜头缩放动画
    switchBanner(index) {
      this.activeIndex = null
      this.$nextTick(() => {
        setTimeout(() => {
          this.activeIndex = index
        }, 10)
      })
    },
    toProduct() {
      this.$router.replace('/product')
      this.$store.commit('toTab/change_atN', 'vr')
    }
  }
}
</script>

<style lang="scss" scoped>
.mt-xs-107 {
  width: 88%;
  margin: auto;
  border-radius: 50px;
  overflow: hidden;
  margin-top: 5px;
  overflow: hidden;
}

// 轮播容器深度样式
.self-carousel ::v-deep {
  z-index: 20;

  // 轮播高度
  .el-carousel__container {
    height: vw(500);
  }

  // 左右切换箭头美化 - 浅白通透风格
  .el-carousel__arrow {
    width: vw(60);
    height: vw(60);
    background: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);

    &:hover {
      background: rgba(255, 255, 255, 0.7);
    }

    i {
      font-size: vw(24);
      color: #0a3058;
    }
  }

  // 轮播指示器圆点
  .el-carousel__indicators {
    bottom: vw(30);
  }

  .el-carousel__indicator {
    opacity: 1;
    padding: 0 vw(12);

    .el-carousel__button {
      width: vw(20);
      height: vw(20);
      background-color: rgba(103, 166, 220, 0.35);
      border-radius: 50%;
      transition: all 0.3s ease;

      &.is-active {
        background-color: #67a6dc;
        transform: scale(1.2);
      }
    }
  }
}

// 背景图+镜头动画核心容器
.img-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  // 背景图镜头拉远动画
  >img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: scale(1.35) translateY(-6%);
    transition: transform 9s cubic-bezier(0.18, 0.9, 0.22, 1);
    will-change: transform;
  }

  &.playAnim>img {
    transform: scale(1) translateY(0);
  }

  // ===================== 优化提亮遮罩层（核心解决过暗问题） =====================
  .mask-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // 上下浅渐变，低透明度，保留原图浅色质感，不再发黑
    background: linear-gradient(to right,
        rgba(6, 32, 64, 0.45) 0%,
        rgba(12, 45, 88, 0.22) 55%,
        rgba(255, 255, 255, 0.08) 100%);
    pointer-events: none;
  }

  // 文字+设备图统一内容层（层级高于遮罩）
  .hero-content {
    position: absolute;
    left: vw(80);
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: vw(60);
    width: calc(100% - vw(160));
    z-index: 2;
    opacity: 0;
    transition: opacity 1.2s ease 0.8s;

    .hero-text {
      flex: 1;
      color: #ffffff;
      text-shadow: 0 1px 8px rgba(0, 30, 80, 0.25);
      text-align: left;
      margin-left: 50px;
    }
    .hero-text-ct{
      margin-left: 70px;
    }

    .hero-image {
      flex-shrink: 0;
      margin-right: 30px;
      img {
        width: 100%;
        height: auto;
        filter: drop-shadow(0 0 24px rgba(103, 166, 220, 0.4));
      }
    }
    .hero-image-mri{
      width: vw(550);
      margin-top: 30px;
      img{
        height: 380px;
      }
    }
    .hero-image-ct{
      width: vw(550);
      margin-top: 30px;
      img{
        height: 360px;
      }
    }
    .hero-image-dr{
      width: vw(410);
      height: 350px;
    }
    .hero-image-desktop{
      width: vw(510);
      height: 350px;
      display: flex;
      img{
        border-radius: 20px;
      }
    }
  }

  // 当前轮播激活时文字渐入
  &.playAnim .hero-content {
    opacity: 1;
  }

  // 顶部标签徽章 - 浅蓝通透医疗风
  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: vw(10);
    padding: vw(8) vw(22);
    background: linear-gradient(90deg, rgba(103, 166, 220, 0.35), rgba(185, 234, 255, 0.25));
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 99px;
    font-size: vw(24);
    letter-spacing: 1px;
    margin-bottom: vw(24);
    backdrop-filter: blur(8px);
  }

  // 主标题 - 柔和浅蓝渐变，不刺眼
  .hero-title {
    font-size: vw(64);
    line-height: 1.2;
    font-weight: 600;
    margin: 0 0 vw(16);

    span {
      display: block;
      font-size: vw(42);
      font-weight: 400;
      background: linear-gradient(90deg, #d0eaff, #ffffff);
      -webkit-background-clip: text;
      color: transparent;
    }
  }

  // 描述文本
  .hero-desc {
    font-size: vw(28);
    line-height: 1.7;
    max-width: vw(680);
    opacity: 0.95;
    margin: 0 0 vw(32);
  }

  // 产品按钮 浅白清爽医疗风
  .product-btn {
    border: 0;
    outline: none;
    font-size: vw(30);
    padding: vw(20) vw(52);
    min-width: vw(240);
    min-height: vw(72);
    line-height: 1;
    letter-spacing: .15em;
    white-space: nowrap;
    cursor: pointer;
    color: #0a3058;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 4px 12px rgba(103, 166, 220, 0.22);
    border-radius: 99px;
    transition: all .28s ease;
    font-weight: 500;

    &:hover {
      transform: translateY(-4px);
      background: #ffffff;
      box-shadow: 0 6px 18px rgba(103, 166, 220, 0.38);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .but {
    width: 120px;
    height: 50px;
    border-radius: 50px;
    border: none;
    background-color: #2563AF;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      box-shadow: 0 0 18px 6px rgba(255, 255, 255, 0.55);
    }
  }
}

// ------------------------------- 移动端适配 <767px -------------------------------
@media only screen and (max-width: 767px) {
  .self-carousel ::v-deep {
    .el-carousel__container {
      height: vp(400);
    }

    .el-carousel__arrow {
      width: vp(40);
      height: vp(40);

      i {
        font-size: vp(18);
      }
    }

    .el-carousel__indicators {
      bottom: vp(15);
    }

    .el-carousel__indicator .el-carousel__button {
      width: vp(14);
      height: vp(14);
    }
  }

  .img-wrap {

    // 移动端轻微加深，保证小字可读
    .mask-layer {
      background: linear-gradient(to right,
          rgba(6, 32, 64, 0.52) 0%,
          rgba(12, 45, 88, 0.28) 60%,
          rgba(255, 255, 255, 0.05) 100%);
    }

    .hero-content {
      left: vp(30);
      width: calc(100% - vp(60));
      flex-direction: column;
      align-items: flex-start;
      gap: vp(30);
    }

    .hero-image {
      width: vp(220);
    }

    .hero-badge {
      font-size: vp(14);
      padding: vp(6) vp(16);
      margin-bottom: vp(12);
    }

    .hero-title {
      font-size: vp(32);

      span {
        font-size: vp(20);
      }
    }

    .hero-desc {
      font-size: vp(16);
      line-height: 1.6;
      margin-bottom: vp(20);
    }

    .product-btn {
      font-size: vp(16);
      padding: vp(14) vp(30);
      min-width: vp(140);
      min-height: vp(44);
      border-radius: 99px;
    }
  }
}
</style>